module.exports = __webpack_public_path__ + "static/media/3_16.90036cbb.png";